<template>
    <label class="choice__label" :class="{ '-selected': isSelected}">
        <input type="radio"
            class="radio-input"
            :name="iname"
            :value="choice.value"
            :checked="isSelected"
            :disabled="disabled || readOnly"
            @change.stop="changeValue"
            :tabindex="questionIndex"
            :aria-labelledby="choiceID"
        >
        <span v-once v-html="choice.label" :id="choiceID"></span> <span class="choice__tip" v-if="isSelected" v-html="tip"></span>
    </label>
</template>

<script>
import { forEach } from 'lodash';
import { TRIGGER_TYPE_ANSWER_TIP } from '../../constants';

export default {
    name: 'radio-button-choice',

    props: {
        questionIndex: Number,
        uukey: String,
        choice: Object,
        triggers: Object,
        answer: [String, Number],
        disabled: Boolean,
        column: {
          type: [String, Number],
          required: false
        },
        name: {
          type: String,
          required: false
        },
        readOnly: {
            type: Boolean,
            default: true,
        },
    },

    data()
    {
        return {
            tip: null,
        };
    },

    beforeMount()
    {
        forEach(this.triggers, (values, key) =>
        {
            switch(key)
            {
                case TRIGGER_TYPE_ANSWER_TIP:
                    this.parseTipTrigger(values);
                    break;
                default:
                    break;
            }
        });
    },

    computed: {
        isSelected()
        {
            if (this.disabled)
            {
                return false;
            }
            return (this.answer == this.choice.value);
        },
        iname()
        {
            return (this.name) ? this.name : this.uukey;
        },
        choiceID()
        {
            return `${this.iname}-${this.choice.value}`;
        }
    },

    methods: {
        changeValue($event)
        {
            this.$parent.changeValue($event.target.value, this.column);
        },

        parseTipTrigger(values)
        {
            forEach(values, (text, targetAnswer) =>
            {
                if (targetAnswer == this.choice.value)
                {
                    this.tip = text;
                }
            });
        },
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/radio-button-choice.vue